import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResponseCustom } from 'src/app/models/ResponseCustom';
import { CollectorFileImportService } from './collector-file-import.service';
import { Router } from '@angular/router';
import * as _ from 'lodash';

@Component({
    selector: 'kt-collector-import-file',
    templateUrl: './collector-file-import.component.html',
    styleUrls: ['./collector-file-import.component.scss'],
})
export class CollectorFileImportComponent implements OnInit {
    constructor(
        private fileImportService: CollectorFileImportService,
        private spinner: NgxSpinnerService,
        private router: Router,
    ) {}

    ngOnInit(): void {}

    selectedFile: File = null;

    responsePostFile: ResponseCustom;

    onSelectFile(fileInputEvent: any) {
        this.selectedFile = <File>fileInputEvent.target.files[0];
        this.upload(fileInputEvent);
    }

    upload(data) {
        const formData = new FormData();
        formData.append('File', this.selectedFile);

        this.spinner.show();
        this.fileImportService.postFile(formData).subscribe((responsePostFile) => {
            this.spinner.hide();

            let queryParams = _.pick(responsePostFile.data, ['id', 'processStatusString']);

            this.router.navigate([`collector-file/collector-file-audit/`, queryParams]);

            this.selectedFile = null;
        });
    }
}
